<div class="page">
	<div class="page-header p-xs-0">
		<div class="col-12 text-start p-xs-1">
			<img alt="Logo" class="logo-img" src="/assets/icons/logo-inverted.svg">
		</div>
	</div>
	<div class="page-content p-xs-0 justify-content-center align-items-center">
		<div class="content">
			<h1>{{ "Hi" | translate }} {{ userFirstname }}</h1>
			<p>{{ "Question_Feel_Today" | translate }}</p>
			<small>{{ "Learn_More_About_You" | translate }}</small>
			<button
				class="btn btn-base-1 d-flex gap-1 align-items-center"
				(click)="navigateTo('home')"
			>
				<div>{{ "Get_Started" | translate }}</div>
				<img
					[attr.alt]="'Get_Started' | translate"
					class="filter-white"
					height="25"
					src="/assets/icons/arrow-right.svg"
				>
			</button>
		</div>
	</div>
</div>
